'use client'
import {
  checkoutData,
  purchaseData
} from "./chunk-SSYZSLGO.mjs";
import {
  __async,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/trackers/reactNative.ts
var ReactNativeTracker = class {
  constructor({ log } = {}) {
    this.setDevice = () => {
    };
    this.setCookieConsent = () => {
    };
    this.pageView = () => {
    };
    this.signupEvent = () => __async(this, null, function* () {
    });
    this.loginEvent = () => __async(this, null, function* () {
    });
    this.setUser = () => {
    };
    this.viewItemEvent = () => __async(this, null, function* () {
    });
    this.viewItemListEvent = () => {
    };
    this.generateLeadEvent = () => {
    };
    this.viewItemBook = (props) => {
      var _a, _b, _c, _d, _e, _f, _g;
      this.postMessageToWebview("EVENT_DETAILS_LOAD", {
        data: {
          productID: (_a = props.event) == null ? void 0 : _a.slug,
          name: (_b = props.event) == null ? void 0 : _b.title,
          taxonomy: (_c = props.event) == null ? void 0 : _c.category,
          imageURL: (_d = props.event) == null ? void 0 : _d.poster,
          price: ((_e = props.event) == null ? void 0 : _e.startingPrice) || props.price,
          currency: ((_f = props.event) == null ? void 0 : _f.currencyCode) || "SAR",
          eventDate: (_g = props.event) == null ? void 0 : _g.start_date_time
        }
      });
    };
    this.cartEvent = () => {
    };
    this.viewSummaryEvent = (props) => {
      var _a, _b, _c, _d, _e, _f, _g;
      const data = checkoutData(props);
      this.postMessageToWebview("BOOKING_SUMMARY", {
        data: {
          event: {
            productID: (_a = props.event) == null ? void 0 : _a.slug,
            name: (_b = props.event) == null ? void 0 : _b.title,
            taxonomy: (_c = props.event) == null ? void 0 : _c.category,
            imageURL: (_d = props.event) == null ? void 0 : _d.poster,
            price: ((_e = props.event) == null ? void 0 : _e.startingPrice) || data.order.value,
            currency: ((_f = props.event) == null ? void 0 : _f.currencyCode) || "SAR",
            eventDate: (_g = props.event) == null ? void 0 : _g.start_date_time
          },
          order: data.order
        }
      });
    };
    this.ticketsSummaryEvent = (props) => {
      var _a, _b, _c, _d, _e, _f, _g;
      this.postMessageToWebview("TICKETS_SUMMARY", {
        data: {
          productID: (_a = props.event) == null ? void 0 : _a.slug,
          name: (_b = props.event) == null ? void 0 : _b.title,
          taxonomy: (_c = props.event) == null ? void 0 : _c.category,
          imageURL: (_d = props.event) == null ? void 0 : _d.poster,
          price: ((_e = props.event) == null ? void 0 : _e.startingPrice) || props.price,
          currency: ((_f = props.event) == null ? void 0 : _f.currencyCode) || "SAR",
          eventDate: (_g = props.event) == null ? void 0 : _g.start_date_time
        }
      });
    };
    this.paymentSummaryEvent = (props) => {
      var _a, _b, _c, _d, _e, _f, _g;
      const data = checkoutData(props);
      this.postMessageToWebview("PAYMENT_SUMMARY", {
        data: {
          event: {
            productID: (_a = props.event) == null ? void 0 : _a.slug,
            name: (_b = props.event) == null ? void 0 : _b.title,
            taxonomy: (_c = props.event) == null ? void 0 : _c.category,
            imageURL: (_d = props.event) == null ? void 0 : _d.poster,
            price: ((_e = props.event) == null ? void 0 : _e.startingPrice) || data.order.value,
            currency: ((_f = props.event) == null ? void 0 : _f.currencyCode) || "SAR",
            eventDate: (_g = props.event) == null ? void 0 : _g.start_date_time
          },
          order: data.order
        }
      });
    };
    this.beginCheckout = (props) => {
      var _a, _b, _c, _d, _e, _f, _g;
      const data = checkoutData(props);
      this.postMessageToWebview("BEGIN_CHECKOUT", {
        data: {
          event: {
            productID: (_a = props.event) == null ? void 0 : _a.slug,
            name: (_b = props.event) == null ? void 0 : _b.title,
            taxonomy: (_c = props.event) == null ? void 0 : _c.category,
            imageURL: (_d = props.event) == null ? void 0 : _d.poster,
            price: ((_e = props.event) == null ? void 0 : _e.startingPrice) || data.order.value,
            currency: ((_f = props.event) == null ? void 0 : _f.currencyCode) || "SAR",
            eventDate: (_g = props.event) == null ? void 0 : _g.start_date_time
          },
          order: data.order
        }
      });
    };
    this.purchaseEvent = (payment) => __async(this, null, function* () {
      const data = purchaseData(payment);
      this.postMessageToWebview("PURCHASE", {
        data,
        order: {
          order_id: payment.order_id,
          total: payment.total
        }
      });
    });
    this.trackEvent = (props) => {
      this.postMessageToWebview(props.event, props.data || {});
    };
    this.purchaseSubscriptionEvent = () => {
    };
    this.purchaseFailed = () => {
    };
    this.shareEvent = () => {
    };
    this.registerInterestEvent = () => {
    };
    this.newsletterEvent = () => {
    };
    /**
     * Unified function to push data to react native
     */
    this.postMessageToWebview = (eventName, data) => {
      var _a;
      if (typeof window !== "undefined") {
        (_a = window.ReactNativeWebView) == null ? void 0 : _a.postMessage(JSON.stringify(__spreadValues({ eventName }, data)));
        if (this.log) {
          console.log("Pushed to ReactName:", __spreadValues({ eventName }, data));
        }
      }
    };
    this.log = !!log;
  }
};

export {
  ReactNativeTracker
};
//# sourceMappingURL=chunk-E4HXNU6L.mjs.map